import React from 'react'

import useStyles from './styles'

const Section = ({ name, children }) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div className={classes.name} data-testid={name}>
        {name}
      </div>

      <div className={classes.children}>{children}</div>
    </div>
  )
}

export default Section
